const tabModuleDetailRoutes = [
  {
    path: 'index',
    name: 'tab_modules.show',
    component: require('./tab-modules/show').default,
    meta: {
      title: '主题详情',
      permission: 'products.read'
    }
  },
  {
    path: 'product_list',
    name: 'tab_modules.product_list',
    component: require('./tab-modules/product-list').default,
    meta: {
      title: '主题产品列表',
      permission: 'products.read'
    }
  }
];

const productDetailRoutes = [
  {
    path: 'index',
    name: 'products.show',
    component: require('./products/show').default,
    meta: {
      title: '产品详情',
      permission: 'products.read'
    }
  },
  {
    path: 'goods_list',
    name: 'products.goods_list',
    component: require('./products/goods-list').default,
    meta: {
      title: '商品列表',
      permission: 'products.read'
    }
  }
];

export default {
  path: '',
  component: {
    template: '<router-view :key="$route.fullPath" />'
  },
  meta: {
    title: '产品管理',
    navbar: 'el-icon-goods'
  },
  children: [
    {
      path: '/products',
      name: 'products.index',
      component: require('./products/index').default,
      meta: {
        title: '产品列表',
        navbar: 'el-icon-s-goods',
        permission: 'products.read'
      }
    },
    {
      path: '/pricing_rules',
      name: 'pricing_rules.index',
      component: require('./pricing_rules/index').default,
      meta: {
        title: '价格规则',
        navbar: 'el-icon-money',
        permission: 'products.update'
      }
    },
    {
      path: '/pricing_rules/new',
      name: 'pricing_rules.new',
      component: require('./pricing_rules/new').default,
      meta: {
        title: '新建价格规则',
        permission: 'products.update'
      }
    },
    {
      path: '/pricing_rules/:id',
      name: 'pricing_rules.show',
      component: require('./pricing_rules/show').default,
      meta: {
        title: '产品价格规则',
        permission: 'products.update'
      }
    },
    {
      path: '/pricing_rules/:id/edit',
      name: 'pricing_rules.edit',
      component: require('./pricing_rules/edit').default,
      meta: {
        title: '修改价格规则',
        permission: 'products.update'
      }
    },
    {
      path: '/products/new',
      name: 'products.new',
      component: require('./products/new').default,
      meta: {
        title: '新建产品',
        permission: 'products.create'
      }
    },
    {
      path: '/products/:id',
      component: require('@/layouts/navbar').default,
      props: { routes: productDetailRoutes },
      meta: {
        title: '产品详情',
        permission: 'products.read'
      },
      children: productDetailRoutes
    },
    {
      path: '/products/:id/edit',
      name: 'products.edit',
      component: require('./products/edit').default,
      meta: {
        title: '修改产品',
        permission: 'products.update'
      }
    },
    {
      path: '/tab_modules',
      name: 'tab_modules.index',
      component: require('./tab-modules/index').default,
      meta: {
        title: '产品主题',
        navbar: 'el-icon-s-goods',
        permission: 'products.read'
      }
    },
    {
      path: '/tab_modules/new',
      name: 'tab_modules.new',
      component: require('./tab-modules/new').default,
      meta: {
        title: '新建产品主题',
        permission: 'products.create'
      }
    },
    {
      path: '/tab_modules/:id',
      component: require('@/layouts/navbar').default,
      props: { routes: tabModuleDetailRoutes },
      meta: {
        title: '产品主题详情',
        permission: 'products.read'
      },
      children: tabModuleDetailRoutes
    },
    {
      path: '/tab_modules/:id/edit',
      name: 'tab_modules.edit',
      component: require('./tab-modules/edit').default,
      meta: {
        title: '修改产品主题',
        permission: 'products.update'
      }
    },
    {
      path: '/categories',
      name: 'categories.index',
      component: require('./categories/index').default,
      meta: {
        title: '分类',
        navbar: 'el-icon-menu',
        permission: 'categories.read'
      }
    },
    {
      path: '/categories/new',
      name: 'categories.new',
      component: require('./categories/new').default,
      meta: {
        title: '新建分类',
        permission: 'categories.create'
      }
    },
    {
      path: '/categories/:id',
      name: 'categories.show',
      component: require('./categories/show').default,
      meta: {
        title: '分类详情',
        permission: 'categories.read'
      }
    },
    {
      path: '/categories/:id/edit',
      name: 'categories.edit',
      component: require('./categories/edit').default,
      meta: {
        title: '修改分类',
        permission: 'categories.update'
      }
    },
    {
      path: '/property_names',
      name: 'property_names.index',
      component: require('./property-names/index').default,
      meta: {
        title: '产品规格',
        navbar: 'el-icon-s-grid',
        permission: 'property_names.read'
      }
    },
    {
      path: '/property_names/new',
      name: 'property_names.new',
      component: require('./property-names/new').default,
      meta: {
        title: '新建产品规格',
        permission: 'property_names.create'
      }
    },
    {
      path: '/property_names/:id',
      name: 'property_names.show',
      component: require('./property-names/show').default,
      meta: {
        title: '产品规格详情',
        permission: 'property_names.read'
      }
    },
    {
      path: '/property_names/:id/edit',
      name: 'property_names.edit',
      component: require('./property-names/edit').default,
      meta: {
        title: '修改产品规格',
        permission: 'property_names.update'
      }
    },
    ...require('./search-records/route').default,
  ]
}
